import { render, staticRenderFns } from "./ai-builder-step.vue?vue&type=template&id=cf000b9a&scoped=true"
import script from "./ai-builder-step.vue?vue&type=script&lang=ts"
export * from "./ai-builder-step.vue?vue&type=script&lang=ts"
import style0 from "./ai-builder-step.vue?vue&type=style&index=0&id=cf000b9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf000b9a",
  null
  
)

export default component.exports